import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { useFeedbackModal } from '@features/feedback'

import { SocialList } from '@widgets/social-list'



import { URL_CHECKOUT } from '@shared/contants'
import Button from '@shared/ui/button'
import { Toc } from '@shared/ui/toc'

import styles from './styles.module.scss'

export default function DeliveryInfo () {
  const { t: t } = useTranslation('InfoDelivery')
  const containerRef = useRef<HTMLDivElement>(null)
  const isMobile = useMediaQuery('(max-width: 768px)')

  const { openFeedbackModal } = useFeedbackModal()

  return (
    <div className={styles.root} ref={containerRef}>
      {isMobile && <Toc containerRef={containerRef} />}
      <div className={styles.common}>
        <h3>{t('1.title')}</h3>
        <p className={styles.common__subtitle}>{t('1.subtitle')}</p>
        <div className={styles.common__social}>
          <SocialList />
        </div>
      </div>
      <div className={styles.common}>
        <h3>{t('2.title')}</h3>
        <p className={styles.common__subtitle}>{t('2.subtitle')}</p>
        <Button 
          onClick={openFeedbackModal}
          size="large"
        >
          {t('button')}
        </Button>
      </div>
      <div className={styles.common}>
        <h3>{t('3.title')}</h3>
        <p className={styles.common__subtitle}>{t('3.subtitle')}</p>
        <div className={styles.common__cards}>
          {/* <div className={styles.common__card}>
            <div className={styles.common__img}>
              <img src="/img/info/delivery/card-1.png" alt="" />
            </div>
            <span
              dangerouslySetInnerHTML={{
                __html: t('3.card-first'),
              }}
            />
          </div>
          <div className={styles.common__card}>
            <div
              className={classNames(
                styles.common__img,
                styles['common__img--right'],
              )}
            >
              <img src="/img/info/delivery/card-2.png" alt="" />
            </div>
            <span>{t('3.card-second')}</span>
          </div> */}
        </div>
      </div>
      <div className={styles.common}>
        <h3>{t('4.title')}</h3>
        <p className={styles.common__subtitle}>{t('4.subtitle')}</p>
      </div>
      <div className={styles.common}>
        <h3>{t('5.title')}</h3>
        <p className={styles.common__subtitle}>{t('5.subtitle')}</p>
        <Button 
          onClick={openFeedbackModal}
          size="large"
        >
          {t('button')}
        </Button>
      </div>
      <div className={styles.common}>
        <h3>{t('6.title')}</h3>
        <div className={styles.common__cards}>
          <div className={styles.common__card}>
            {/* <div
              className={classNames(
                styles.common__img,
                styles['common__img--top'],
                styles['common__img--grey'],
              )}
            >
              <img src="/img/info/delivery/card-3.svg" alt="" />
            </div> */}
            <span>
              {t('6.card-first')} <a href={URL_CHECKOUT}>{t('6.card-first-link')}</a>.
            </span>
          </div>
          <div className={styles.common__card}>
            {/* <div
              className={classNames(
                styles.common__img,
                styles['common__img--grey'],
              )}
            >
              <img src="/img/info/delivery/card-4.svg" alt="" />
            </div> */}
            <span>{t('6.card-second')}</span>
          </div>
        </div>
      </div>
      {/* <div className={styles.common}>
        <h3>{t('7.title')}</h3>
        <p className={styles.common__subtitle}>{t('7.subtitle-first')}</p>
        <div className={styles.root__description}>
          <span>{t('7.description')}</span>
        </div>
        <p className={styles.common__subtitle}>{t('7.subtitle-second')}</p>
      </div> */}
      {/* <div className={styles.root__banner}>
        <BannerApp />
      </div> */}
    </div>
  )
}
